import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { Button } from "@/modules/theme/components/Button/Button";
import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";

import { ReactComponent as Tick } from "../icons/tick.svg";
import { createTaskStatusTogglerStyles } from "../styles/createTaskStatusTogglerStyles";

type TaskStatusTogglerProps = {
  done: boolean;
  formId?: string;
  onButtonClick?: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
};

const translationNamespace = "pages/SubtaskDetailsPage";

export const TaskStatusToggler: React.FC<TaskStatusTogglerProps> = ({
  done,
  formId,
  onButtonClick,
  isLoading = false,
  isDisabled = false,
}) => {
  const classes = createTaskStatusTogglerStyles(useTheme());
  const { t } = useTranslation(translationNamespace);

  return (
    <div
      className={cx(classes.root, {
        [classes.done]: done,
      })}
    >
      <Typography
        variant="contentLarge"
        className={cx(classes.text, {
          [classes.textInvisible]: done,
        })}
      >
        {t("Did you complete the task?")}
      </Typography>
      <Button
        className={classes.button}
        isLoading={isLoading}
        disabled={isDisabled}
        onClick={onButtonClick}
        type="submit"
        form={formId}
      >
        {done ? (
          <>
            <Tick className={classes.tick} />
            {t("Done")}
          </>
        ) : (
          t("Yes")
        )}
      </Button>
    </div>
  );
};
